import { render } from "./DocCenter.vue?vue&type=template&id=43c6b48e"
import script from "./DocCenter.vue?vue&type=script&lang=js"
export * from "./DocCenter.vue?vue&type=script&lang=js"

import "./DocCenter.vue?vue&type=style&index=0&id=43c6b48e&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/build_logistics-fe-ntp-hz_cb461e37a40e4d4db048201803700c7a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__